import { Component, OnInit, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, Input, Type, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { ActionSheetController, AlertController, IonContent, NavController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { Logger } from 'src/app/api/helper/app-error-logger';

// https://stackoverflow.com/questions/38080654/ionic-2-angular-2-images-prepended-with-unsafe-therefore-not-displaying-ev
import { DomSanitizer } from '@angular/platform-browser';
import { MyApp } from 'src/app/api/helper/app';
import { Auftragdetails } from '../auftragdetails.helper';
import { Subscription } from 'rxjs';
import { Auftragstyp, WizardPage, WorkflowStatus } from 'src/app/api/model/swagger-model';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';
import { I18N } from 'src/app/api/helper/i18n';
import { Util } from 'leaflet';
import { Utils } from 'src/app/api/helper/utils';


@Component({
    selector: 'app-auftragdetails-wizard',
    templateUrl: './auftragdetails-wizard.component.html',
    styleUrls: ['./auftragdetails-wizard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragdetailsWizardComponent implements OnInit, OnDestroy {
    log = new Logger("AuftragdetailsWizardComponent");

    @Input() auftragdetails: Auftragdetails;

    app = MyApp.current;

    key: string = null;
    auftragsnummer: number = null;
    unterMandant = '';
    standardFertigStatus: WorkflowStatus = null;

    geladen = false;
    isDestroyed = false;
    isVisible = false;
    initialisiert = false;
    isModalSichtbar = false;
    weiterVerfuegbar = false;

    subscriptions: Subscription[] = [];

    statuszusatzinfoModal: HTMLIonModalElement;

    wizardPage: WizardPage;

    // wizardPages: WizardPageVO[] = [];

    /** Aktuell angezeigte Wizard-Page */
    currentIndex = 0;

    /** Ist der ...-Button deaktiviert? */
    mehrDisabled = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertController: AlertController,
        private actionSheetController: ActionSheetController,
        private componentFactoryResolver: ComponentFactoryResolver,
        public domSanitizationService: DomSanitizer,
        private cdr: ChangeDetectorRef,
        private nav: NavController) {

    }

    get auftrag() { return this.auftragdetails.auftrag; };

    get workflow() { return this.auftragdetails.workflow; };

    get formularKonfiguration() { return this.auftragdetails.formularKonfiguration; };

    get checklisten() { return this.auftragdetails.checklisten; };

    get auftragsbilder() { return this.auftragdetails.auftragsbilder; };

    get bilder() { return this.auftragdetails.bilder; };

    get buttons() { return this.auftragdetails.buttons; };

    get buttons2() { return this.auftragdetails.buttons2; };

    get buttons3() { return this.auftragdetails.buttons3; };

    async ngOnInit() {
        this.log?.debug('ngOnInit');

        try {
            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => { this.detectChanges(info); }));

            this.currentIndex = 0;

            const pageIndex = this.route.snapshot.paramMap.get('pageIndex');

            if (pageIndex) {
                this.currentIndex = +pageIndex;
            }

            this.initWizardPage();

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => this.detectChanges(info)));
            this.subscriptions.push(this.auftragdetails.auftragAbgeschlossen.subscribe(() => this.onAuftragAbgeschlossen()));
            this.subscriptions.push(this.auftragdetails.lieferungAnzeigen.subscribe(() => this.onLieferungAendern()));
            this.subscriptions.push(this.auftragdetails.druckenAnzeigen.subscribe(workflowStatus => this.onDrucken(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.bezahlenAnzeigen.subscribe(workflowStatus => this.onBezahlen(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.weiterleitenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenWeiterleiten(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.scrollToButtons.subscribe(() => this.onScrollToButtons()));
            this.subscriptions.push(this.auftragdetails.anmerkungenAnzeigen.subscribe(() => this.auftragdetails.anzeigenAnmerkungen()));

            this.detectChanges('ngOnInit: ' + this.wizardPage?.Titel);

            MyApp.current.backAction = () => this.goBack();

            this.initialisiert = true;
        } catch (err) {
            this.log.error('ngOnInit', err);
        }
    }

    initWizardPage() {
        let wizardPages = this.auftragdetails?.workflow?.WizardKonfiguration?.WizardPages;

        if (!wizardPages) {
            this.log.error('wizardPages darf nicht null sein')
            return;
        }

        wizardPages = wizardPages.filter(p => p.Aktiv);

        if (this.currentIndex < 0) {
            this.log.error('currentIndex darf nicht < 0 sein')
            return;
        }

        if (this.currentIndex >= wizardPages.length) {
            this.log.error('currentIndex darf nicht > wizardPages.length sein')
            return;
        }

        this.wizardPage = wizardPages[this.currentIndex];

        this.weiterVerfuegbar = this.getNextIndex() > 0;

        if (!this.weiterVerfuegbar) {
            // Wir sind auf der ltzten Seite
            // Prüfe ob es eine Standard-Fertig-Aktion gibt
            this.standardFertigStatus = this.workflow.status.find(p => p.StandardFertigAktion);
        }

        this.mehrDisabled = this.isMehrDisabled();
    }

    /**
     * Gibt zurück ob der ...-Button deaktiviert sein soll.
     * Das ist der Fall, wenn es keine Statusmeldungen auf dieser Seite gibt.
     */
    isMehrDisabled(): any {
        if (!this.wizardPage.Statusmeldungen) {
            return true;
        }

        let statusmeldungen = this.getStatusmeldungenAufAktuellerSeite();

        if (statusmeldungen.length === 0) {
            return true;
        }

        // Nicht deaktiviert
        return false;
    }

    onZurueck() {
        this.log.dev('onZurueck');

        const prevIndex = this.getPrevIndex();

        if (prevIndex >= 0) {
            this.nav.navigateBack('/auftragsliste/details/' + this.auftrag.Key + '/wizard/' + (prevIndex));
        } else {
            this.goBack();
        }
    }

    private getStatusmeldungenAufAktuellerSeite(): WorkflowStatus[] {
        if (!this.wizardPage?.Statusmeldungen) {
            return [];
        }

        let statusmeldungen: WorkflowStatus[] = [];

        for (const key in this.wizardPage.Statusmeldungen) {
            if (Object.prototype.hasOwnProperty.call(this.wizardPage.Statusmeldungen, key)) {
                const value = this.wizardPage.Statusmeldungen[key];

                if (value) {
                    // Diese Statusmeldung ist erlaubt
                    // Key kann sein: Id oder name
                    const workflowStatus = this.workflow.status.find(p => p.id != null && p.id.toString() == key);

                    if (workflowStatus) {
                        statusmeldungen.push(workflowStatus);
                    }
                }
            }
        }

        return statusmeldungen;
    }

    async onMehr() {
        this.log.dev('onMehr');

        if (!this.wizardPage.Statusmeldungen) {
            this.wizardPage.Statusmeldungen = {};
        }

        let statusmeldungen = this.getStatusmeldungenAufAktuellerSeite();

        if (!statusmeldungen.length) {
            this.log?.info('onMehr: Keine Statusmeldung auf dieser Seite verfügbar');
            return;
        }

        const buttons: any[] = [];

        statusmeldungen.sort((a, b) => a.sortierung - b.sortierung);

        if (this.auftragdetails.istAuftragAbgeschlossen) {
            statusmeldungen = statusmeldungen.filter(p => p.NachAbschlussErlaubt).sort((a, b) => a.sortierung - b.sortierung);

            if (!statusmeldungen.length) {
                this.auftragdetails.showAuftragArchiviert();
                return;
            }
        }

        for (const status of statusmeldungen) {
            let role = '';

            if (status.auftragsstatus === Auftragsstatus.Abgelehnt) {
                role = 'destructive';
            }

            buttons.push({
                text: status.name,
                icon: status.icon,
                role: role,
                handler: () => {
                    this.statusMelden(status, true);
                }
            });
        }

        buttons.push({
            text: I18N.instant('Abbrechen'),
            icon: 'close',
            role: 'cancel',
            handler: () => { }
        });

        const alert = await this.alertController.create({
            header: I18N.instant('Statusmeldung'),
            cssClass: 'no-text-alert',
            mode: 'ios',
            buttons: buttons
        });

        await alert.present();
    }

    async onWeiter() {
        this.log.dev('onWeiter');

        this.auftragdetails.beaforePageLeave.next('onWeiter');

        // Delay ist erforderlich, damit der Cursor aus den Input-Feldern verschwindet und damit die Daten übernommen werden.
        UiHelper.blurActiveElement();
        await Utils.delay(50);

        const abschlussBedingungen = this.wizardPage.AbschlussBedingung;

        if (abschlussBedingungen) {
            if (abschlussBedingungen.LieferungVollstaendig) {
                const fehlertext = this.auftragdetails.pruefeAuftragspositionenVollstaendig();

                if (fehlertext) {
                    UiHelper.showAlert('Bitte Auftragspositionen vollständig ausfüllen. ' + fehlertext);
                    return;
                }
            }

            if (abschlussBedingungen.UnterschriftenVollstaendig) {
                const fehlertext = this.auftragdetails.pruefeUnterschriftenVollstaendig();

                if (fehlertext) {
                    UiHelper.showAlert(fehlertext);
                    return;
                }
            }

            if (abschlussBedingungen.WiegungErfolgreich) {
                if (!this.auftrag.WiegungErfolgreich) {
                    UiHelper.showAlert('Wiegung ist erforderlich');
                    return;
                }
            }

            if (abschlussBedingungen.Statusmeldung) {
                if (!this.auftrag.statusmeldungen?.length) {
                    UiHelper.showAlert('Statusmeldung ist erforderlich');
                    return;
                }
            }

            if (abschlussBedingungen.ChecklisteVollstaendig) {
                const fehlertext = await this.auftragdetails.pruefeChecklistenVollstaendig();

                if (fehlertext) {
                    UiHelper.showAlert('Bitte Checklisten vollständig ausfüllen: ' + fehlertext);
                    return;
                }
            }
        }

        const nextIndex = this.getNextIndex();

        if (nextIndex > 0) {
            this.nav.navigateForward('/auftragsliste/details/' + this.auftrag.Key + '/wizard/' + (nextIndex));
        }
    }

    onFertig(status: WorkflowStatus) {
        this.auftragdetails.statusMelden(status, true);
    }

    /**
     * Sucht den nächsten Seiten-Index für die Anzeige
     */
    getNextIndex() {
        const wizardPages = this.auftragdetails.workflow.WizardKonfiguration.WizardPages.filter(p => p.Aktiv);

        if (this.currentIndex >= wizardPages.length - 1) {
            return -1;
        }

        for (let i = this.currentIndex + 1; i < wizardPages.length; i++) {
            const wizardPage = wizardPages[i];
            const sichtbar = this.isAnzeigeBedingungErfuellt(wizardPage);

            if (sichtbar) {
                return i;
            }
        }

        return -2;
    }

    /**
     * Sucht den nächsten Seiten-Index für die Anzeige
     */
    getPrevIndex() {
        const wizardPages = this.auftragdetails.workflow.WizardKonfiguration.WizardPages.filter(p => p.Aktiv);

        if (this.currentIndex <= 0) {
            return -1;
        }

        for (let i = this.currentIndex - 1; i < wizardPages.length; i--) {
            const wizardPage = wizardPages[i];
            const sichtbar = this.isAnzeigeBedingungErfuellt(wizardPage);

            if (sichtbar) {
                return i;
            }
        }

        return -2;
    }

    isAnzeigeBedingungErfuellt(wizardPage: WizardPage) {
        if (wizardPage.AnzeigeBedingung) {
            let bedingungVorhanden = false;
            let bedingungErfuellt = false;

            if (wizardPage.AnzeigeBedingung.AnlagenVorhanden) {
                bedingungVorhanden = true;
                bedingungErfuellt = bedingungErfuellt || (this.auftrag.Anlagen && this.auftrag.Anlagen.length > 0);
            }

            if (wizardPage.AnzeigeBedingung.HinweistexteVorhanden) {
                bedingungVorhanden = true;
                bedingungErfuellt = bedingungErfuellt || (this.auftrag.Hinweistexte && this.auftrag.Hinweistexte.length > 0);
            }

            if (wizardPage.AnzeigeBedingung.ChecklisteVorhanden) {
                bedingungVorhanden = true;
                bedingungErfuellt = bedingungErfuellt || (this.auftrag.ChecklistenVorgabe && this.auftrag.ChecklistenVorgabe.length > 0);
            }

            if (wizardPage.AnzeigeBedingung.VerwerteradresseVorhanden) {
                bedingungVorhanden = true;
                bedingungErfuellt = bedingungErfuellt || (!!this.auftrag.Verwerteradresse && !!this.auftrag.Verwerteradresse.Name1);
            }

            if (bedingungVorhanden) {
                return bedingungErfuellt;
            }
        }

        return true;
    }

    onAuftragAbgeschlossen(): void {
        this.log?.debug('onAuftragAbgeschlossen: ' + this.auftrag?.Key);

        switch (this.auftrag.Auftragstyp) {
            case Auftragstyp.Hofchecker:
                this.nav.navigateBack('/auftragsliste/hofchecker');
                break;
            case Auftragstyp.Kommissionierung:
                this.nav.navigateBack('/auftragsliste/kommissionierung');
                break;
            case Auftragstyp.Wareneingang:
                this.nav.navigateBack('/auftragsliste/wareneingang');
                break;
            default:
                this.nav.navigateBack('/auftragsliste/aktuell');
                break;
        }
    }

    onLieferungAendern(): void {
        this.log?.debug('onLieferungAendern: ' + this.auftrag?.Key);
        this.auftragdetails.lieferungAendern();
    }

    onDrucken(workflowStatus: WorkflowStatus): void {
        this.log?.debug('onDrucken: ' + this.auftrag?.Key);
        this.auftragdetails.anzeigenDrucken(workflowStatus);
    }

    onBezahlen(workflowStatus: WorkflowStatus): void {
        this.log?.debug('onBezahlen: ' + this.auftrag?.Key);
        this.auftragdetails.anzeigenBezahlen(workflowStatus);
    }

    onScrollToButtons(): void {
        // Wird nicht benötigt
    }

    detectChanges(info: string) {
        if (!this.isDestroyed) {
            this.log?.debug('detectChanges: ' + info);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy: ' + this.wizardPage?.Titel);

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.isDestroyed = true;

        MyApp.current.backAction = null;
    }

    async ionViewWillEnter() {
        this.log?.debug('ionViewWillEnter');
    }

    async ionViewDidEnter() {
        this.log?.debug('ionViewDidEnter');
        this.isVisible = true;

        this.detectChanges('ionViewDidEnter');
    }

    ionViewWillLeave() {
        this.isVisible = false;
    }

    async goBack() {
        this.log?.debug('goBack');

        if (this.currentIndex > 0) {
            this.onZurueck();
            return;
        }

        // if (this.anzeigeBild) {
        //     this.log?.debug('goBack abbruch wegen anzeigeBild');
        //     this.anzeigeBild = null;
        //     return;
        // }

        // if (this.alertAktiv) {
        //     this.log?.debug('goBack abbruch wegen alertAktiv');
        //     // ignoriere Hardware-Back-Button
        //     return;
        // }

        // if (this.kameraAktiv) {
        //     this.log?.debug('goBack abbruch wegen kameraAktiv');
        //     // ignoriere Hardware-Back-Button
        //     return;
        // }

        const auftrag = this.auftragdetails.auftrag;

        if (auftrag) {
            if (auftrag.OberAuftragKey) {
                await this.nav.navigateBack('/auftragsliste/details/' + auftrag.OberAuftragKey);
            } else {
                await this.nav.navigateBack('/auftragsliste/aktuell/' + auftrag.Auftragstyp);
            }
        } else {
            await this.nav.navigateRoot('/');
        }
    }

    async statusMelden(status: WorkflowStatus, mitRueckfrage: boolean): Promise<void> {
        await this.auftragdetails.statusMelden(status, mitRueckfrage);
    }
}

// interface WizardPageVO {
//     titel: string;
//     position?: number;
//     komponente: AuftragsKomponente;
//     component: Type<WizardPageComponentBase>;
//     componentProps?: any;
// }